import { SystemField } from "./system-field";

export class SetupStep extends SystemField{
    name?:string;
    ordering?:number;
    is_config?:number;
}

export class SetupStepTranslate extends SystemField{
    lang_code?:string;
    label?:string;
    description?:string;
    setup_steps_id?:string;
}
